import _taggedTemplateLiteral from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { themeLss } from "../../lss";
import styled, { css } from "../../styled";
import { buttonStyles } from './buttonStyles';
var horizontalScale = {
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};
var verticalScale = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var fontSizeScale = {
  sm: 'control',
  md: 'control',
  lg: 'content'
};

var buttonScale = function buttonScale(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'md' : _ref$scale,
      theme = _ref.theme;
  var horizontalPadding = theme.space[horizontalScale[scale]];
  var verticalPadding = theme.space[verticalScale[scale]];
  var typography = theme.typography[fontSizeScale[scale]];
  return _objectSpread({
    padding: "".concat(verticalPadding, " ").concat(horizontalPadding)
  }, typography, {
    lineHeight: 1
  });
};

export var buttonCss = css(buttonScale, function (_ref2) {
  var theme = _ref2.theme,
      disabled = _ref2.disabled,
      isBlock = _ref2.isBlock;
  return ["\n    cursor: ".concat(disabled ? 'not-allowed' : 'pointer', ";\n    border: ").concat(theme.borders.regular, ";\n    border-radius: ").concat(theme.radii.sm, ";\n    transition: all ").concat(theme.transitions.fast, ", background ").concat(theme.transitions.slow, ";\n    opacity: ").concat(disabled ? theme.opacities.disabled : 1, ";\n    background-position: center;\n    text-decoration: none;\n    ").concat(isBlock ? "\n        display: block;\n        width: 100%;\n        border-radius: 0;\n      " : "\n        display: inline-block;\n        ", "\n    ")];
}, buttonStyles);
/**
 * Our basic button component
 */

export var Button = styled.button(_templateObject(), buttonCss, themeLss());